import React from "react";
import { motion } from "framer-motion";
import Logo from "@/components/portal/Logo";
import ReviewAssistant from "@/components/portal/ReviewAssistant";

export default function Review() {
  return (
    <div className="min-h-screen bg-ivory flex flex-col">
      <header className="px-6 sm:px-10 pt-8">
        <div className="flex justify-center">
          <Logo size="sm" withMonogram={false} />
        </div>
      </header>

      <main className="flex-1 px-5 py-12 sm:py-16 flex items-center justify-center">
        <motion.section
          data-testid="standalone-review-page"
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.55, ease: "easeOut" }}
          className="w-full max-w-xl"
        >
          <div className="text-center">
            <p className="overline text-[10px]">Tanish Textiles</p>
            <h1 className="font-serif font-light text-4xl sm:text-5xl text-ink mt-3">
              Share your experience
            </h1>
            <div className="divider-thin" />
            <p
              data-testid="standalone-review-intro"
              className="text-sm sm:text-base text-muted2 max-w-md mx-auto leading-relaxed"
            >
              Choose the parts of your visit you&rsquo;d like to mention. You can edit the
              suggested review before sharing it on Google.
            </p>
          </div>

          <div className="mt-10 bg-white border border-line rounded-3xl px-5 py-8 sm:px-8 sm:py-10">
            <ReviewAssistant mode="standalone" />
          </div>
        </motion.section>
      </main>
    </div>
  );
}